import {IUserMatriculeByCompany} from "@/models/companyMatricule/IUserMatriculeByCompany";
import {IFormkitDropDown} from "@/models/formkit/dropDown/IFormkitDropDown";
import {ref} from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";

export async function fetchUserMatriculesByCompany(
    companyUuid: string,
    itemsPerPage: number,
    page: number,
    globalSearch?: null|string,
    sort?: { fieldLabel: string; fieldValue: string; },
    available?: boolean
): Promise<[boolean, number, IUserMatriculeByCompany[]]> {
    const isLoading = ref<boolean>(true);
    const totalRecords = ref<number>(0);
    const tableData = ref<Array<IUserMatriculeByCompany>>([]);
    let params = {
        itemsPerPage: itemsPerPage,
        page: page,
        search: globalSearch,
        available: available
    };

    if (isNotEmpty(globalSearch)) {
        params = { ...params, search: globalSearch?.trim() };
    }

    if (available !== undefined) {
        params = { ...params, available: available };
    }

    if (sort !== undefined) {
        const { fieldValue, fieldLabel } = sort;
        params = {...params, [fieldLabel]: fieldValue};
    }

    try {
        const { data } = await ApiService.get(`admin/user-matricules-by-company/` + companyUuid, {
            headers: { Accept: 'application/ld+json' },
            params: params
        });

        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value = data.data['hydra:member'];
    } catch (error) {
        swal.error('Une erreur est survenue au chargement des matricules de la société');
        console.error('Error fetching user matricule by company:', error);
    }
    isLoading.value = false;

    return [isLoading.value, totalRecords.value, tableData.value];
}

export async function fetchCompanyMatricule(uuid: string): Promise<[boolean, IUserMatriculeByCompany|null]> {
    const companyMatricule = ref<IUserMatriculeByCompany | null>(null);
    const isLoading = ref<boolean>(true);
    
    try {
        const { data } = await ApiService.get(`admin/company-matricules/${uuid}`, {
            headers: { Accept: 'application/ld+json' },
        });
        companyMatricule.value = data.data;
    } catch (error) {
        swal.error('An error occurred while fetching companyMatricule.');
    }
    isLoading.value = false;

    return [isLoading.value, companyMatricule.value];
}

export const toggleCompanyMatriculeAvailable = async (data: IUserMatriculeByCompany): Promise<boolean> => {
    try {
        await ApiService.patchWithoutSlug(`/admin/company-matricule/available/${data.uuid}`, {})
            .then(() => {
                return true;
            });

        return true;
    } catch (error) {
        return false;
    }
}

const isNotEmpty = (value: any) => {
    return value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '');
}